import { SERVER_DAY_FORMAT } from 'lib/config';
import routeQuery from 'lib/routeQuery';
import { times } from 'lodash';
import moment, { Moment } from 'moment';
import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getSites } from 'state/AccountTree';
import { getIsBulkDeleteOpened } from 'state/Roster/BulkActions/selectors';
import { currentTimeBySiteTimezoneSelector } from 'state/Roster/Roster/selectors';
import { fromBySiteTimezoneSelector, getSiteId } from 'state/RosteredShifts';
import { StoreState } from 'state/types';
import { AccountTreeSite, StringMap } from 'type';
import { getIsCovidModeEnabled } from '../../../../../../state/Roster/CovidTracing';
import {
  RosterWeekNavigation,
  RosterWeekNavigationDay,
} from '../../../../components';
import { 
  fetchDutyRequirements, 
  getDutyRequirementsByWeekDay,
  DutyRequirementsByDay 
} from 'state/Roster/DutyRequirements';
import { getFlag } from 'state/Flags';
import './WeekNavigation.scss';

export type OwnProps = {
  dayViewPath: string;
};

export type StateProps = {
  site_id: string;
  startDate: Moment;
  sites: StringMap<AccountTreeSite>;
  isBulkDelete: boolean;
  currentTimeBySiteTimezone: Moment;
  isCovidMode: boolean;
  dutyRequirementsByDay: DutyRequirementsByDay[];
  isDutiesFeatureEnabled: boolean;
};

export type DispatchProps = {
  fetchDutyRequirements: (siteId: string) => void;
};

export type Props = OwnProps & StateProps & DispatchProps;

export class WeekNavigationComponent extends Component<Props> {
  componentDidMount() {
    const { site_id, fetchDutyRequirements, isDutiesFeatureEnabled } = this.props;
    
    // Only fetch duty requirements if the feature flag is enabled
    if (isDutiesFeatureEnabled) {
      fetchDutyRequirements(site_id);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { site_id, fetchDutyRequirements, isDutiesFeatureEnabled } = this.props;
    
    // Refetch if site changes and feature is enabled
    if (isDutiesFeatureEnabled && prevProps.site_id !== site_id) {
      fetchDutyRequirements(site_id);
    }
  }

  render() {
    return <RosterWeekNavigation days={this.createDateDays()} />;
  }

  private createDateDays(): RosterWeekNavigationDay[] {
    const {
      startDate,
      currentTimeBySiteTimezone,
      isBulkDelete,
      isCovidMode,
      dutyRequirementsByDay,
    } = this.props;

    return times(7, (n): RosterWeekNavigationDay => {
      const day = moment.parseZone(startDate).add(n, 'day');
      const dayOfWeek = day.format('dddd').toLowerCase();

      const title = day.format('ddd DD');
      const current = currentTimeBySiteTimezone.isSame(day, 'day');
      const path =
        !isBulkDelete && !isCovidMode ? this.getDayPagePath(day) : undefined;

      // Find duties for this day
      const dayDuties = dutyRequirementsByDay.find(
        (d) => d.day === dayOfWeek
      );

      return {
        title,
        current,
        path,
        duties: dayDuties?.duties || [],
      };
    });
  }

  private getDayPagePath(dayMoment: Moment): string {
    const { site_id, dayViewPath } = this.props;
    return (
      dayViewPath +
      routeQuery.stringify({
        site_id,
        day: dayMoment.format(SERVER_DAY_FORMAT),
      })
    );
  }
}

const mapStateToProps = (state: StoreState): StateProps => ({
  site_id: getSiteId(state),
  startDate: fromBySiteTimezoneSelector(state),
  sites: getSites(state),
  isBulkDelete: getIsBulkDeleteOpened(state),
  currentTimeBySiteTimezone: currentTimeBySiteTimezoneSelector(state),
  isCovidMode: getIsCovidModeEnabled(state),
  dutyRequirementsByDay: getDutyRequirementsByWeekDay(state),
  isDutiesFeatureEnabled: getFlag.duties(state),
});

const mapDispatchToProps: DispatchProps = {
  fetchDutyRequirements,
};

export const WeekNavigation = connect(
  mapStateToProps,
  mapDispatchToProps
)(WeekNavigationComponent);

export default WeekNavigation;
